/* EG Collections — Picker */

(function () {

function egGetCollectionPickerConfig(handle) {
  var cfg = window.EG_COLLECTION_PICKERS || {};
  var byHandle = cfg.handles || {};
  if (handle && byHandle[handle]) return byHandle[handle];
  return cfg.default || null;
}

function egFindPickerTagGroup(handle, key) {
  var all = window.EG_COLLECTION_FILTERS || {};
  var col = (all.collections && all.collections[handle]) ? all.collections[handle] : null;
  var groups = (col && col.tagGroups) ? col.tagGroups : [];

  for (var i = 0; i < groups.length; i++) {
    if (groups[i] && groups[i].key === key) return groups[i];
  }
  return null;
}

function egBuildPickerTagHandle(fullTag) {
  if (typeof egBuildTagHandle === "function") return egBuildTagHandle(fullTag);
  return String(fullTag || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function egSetPickerSelectionsInUrl(root, pickerCfg, answers, omitKeysMap, forceDbMode) {
  if (!root || !pickerCfg) return;

  var handle = String(root.getAttribute("data-eg-collection") || "");
  omitKeysMap = omitKeysMap || {};
  forceDbMode = !!forceDbMode;
  var u = new URL(window.location.href);
  var sp = new URLSearchParams();

  var i;
  var moveVal = "";
  var priorityVal = "";

  for (i = 0; i < pickerCfg.steps.length; i++) {
    var step = pickerCfg.steps[i];
    if (!step || !step.key) continue;
    if (omitKeysMap[step.key]) continue;

    var longKey = "eg_tag_" + step.key;
    var filterMode = String(step.filter_mode || "");

    if (step.key === "movement_space") {
      moveVal = String(answers[step.key] || "");
    }

    if (step.key === "secondary_priority") {
      priorityVal = String(answers[step.key] || "");
    }

    // Only tag-based picker steps write filters to the URL
    if (filterMode !== "tag" && filterMode !== "tag_multi") continue;

    var answer = answers[step.key];
    if (!answer) continue;
    if (answer === "__any__") continue;

    var values = Array.isArray(answer) ? answer : [answer];
    var tagGroup = egFindPickerTagGroup(handle, step.key);
    var prefix = "";

    if (tagGroup && tagGroup.match && tagGroup.match.startsWith) {
      prefix = String(tagGroup.match.startsWith || "");
    }

    for (var v = 0; v < values.length; v++) {
      var rawValue = String(values[v] || "");
      if (!rawValue) continue;

      if (prefix && rawValue.indexOf(prefix) === 0) {
        rawValue = rawValue.slice(prefix.length);
      }

      rawValue = String(rawValue || "").replace(/^\s+|\s+$/g, "");

      var suffixHandle = egBuildPickerTagHandle(rawValue);
      if (!suffixHandle) continue;

      sp.append(longKey, suffixHandle);
    }
  }

 if (moveVal) {
    sp.set("eg_pick_move", moveVal);
  }

  if (priorityVal) {
    sp.set("eg_pick_priority", priorityVal);
  }

  if (forceDbMode) {
    sp.set("eg_show_legacy", "1");
  }

  u.search = sp.toString();

  history.replaceState({}, "", u.toString());

  if (typeof egApplyPrettyUrlToAddressBar === "function") {
    try { egApplyPrettyUrlToAddressBar(); } catch (e1) {}
  }

  if (root && typeof root.__egClientRenderRefresh === "function") {
    root.__egClientRenderRefresh();
  } else if (typeof egCollectionsRefresh === "function") {
    egCollectionsRefresh(root);
  } else if (typeof egClientRenderRefresh === "function") {
    egClientRenderRefresh(root);
  } else if (typeof egClientRenderInit === "function") {
    egClientRenderInit(root);
  }
}

function bindCollectionPicker(root) {
  if (!root || root.__egCollectionPickerBound) return;
  root.__egCollectionPickerBound = true;

  var handle = String(root.getAttribute("data-eg-collection") || "");
  var cfg = egGetCollectionPickerConfig(handle);

  var pickerRoot = document.querySelector("[data-eg-picker-root]");
  if (!pickerRoot) return;

  if (!cfg || !cfg.steps || !cfg.steps.length) {
    pickerRoot.style.display = "none";
    return;
  }

  var startBtn = pickerRoot.querySelector("[data-eg-picker-start]");
  var resetBtn = pickerRoot.querySelector("[data-eg-picker-reset]");
  var closeBtn = pickerRoot.querySelector("[data-eg-picker-close]");
  var panel = pickerRoot.querySelector("[data-eg-picker-panel]");
  var progressEl = pickerRoot.querySelector("[data-eg-picker-progress]");
  var questionEl = pickerRoot.querySelector("[data-eg-picker-question]");
  var optionsEl = pickerRoot.querySelector("[data-eg-picker-options]");
  var backBtn = pickerRoot.querySelector("[data-eg-picker-back]");
  var applyBtn = pickerRoot.querySelector("[data-eg-picker-apply]");
  var editBtn = pickerRoot.querySelector("[data-eg-picker-edit]");
  var dbCtaBtn = pickerRoot.querySelector("[data-eg-picker-db-cta]");
  var resultMetaBox = pickerRoot.querySelector("[data-eg-picker-result-meta]");
  var resultTitleEl = pickerRoot.querySelector("[data-eg-picker-result-title-text]");
  var resultDbNoteEl = pickerRoot.querySelector("[data-eg-picker-db-note]");
  var resultPicksEl = pickerRoot.querySelector("[data-eg-picker-result-picks]");
  var resultSummaryBox = pickerRoot.querySelector("[data-eg-picker-result-summary]");
  var resultSummaryTitleEl = pickerRoot.querySelector("[data-eg-picker-summary-title]");
  var resultSummaryListEl = pickerRoot.querySelector("[data-eg-picker-summary-list]");
  var helpTitleEl = pickerRoot.querySelector("[data-eg-picker-help-title]");
  var helpTextEl = pickerRoot.querySelector("[data-eg-picker-help-text]");
  var helpListEl = pickerRoot.querySelector("[data-eg-picker-help-list]"); 
  var titleEl = pickerRoot.querySelector(".eg-collection-picker__title");
  var header = pickerRoot.closest ? pickerRoot.closest(".eg-collection-header") : null;

  function setPickerOpenState(on) {
    if (pickerRoot && pickerRoot.classList) {
      pickerRoot.classList.toggle("is-open", !!on);
    }

    if (header && header.classList) {
      header.classList.toggle("eg-picker-open", !!on);
    }
  }

  function setPickerResultsState(on) {
    if (pickerRoot && pickerRoot.classList) {
      pickerRoot.classList.toggle("eg-picker-results", !!on);
    }

    if (helpTitleEl && helpTitleEl.classList) {
      helpTitleEl.classList.toggle("is-applied", !!on);
    }
  }

  if (!startBtn || !panel || !progressEl || !questionEl || !optionsEl || !backBtn || !applyBtn) return;

  if (titleEl && cfg.title) titleEl.textContent = String(cfg.title);
  if (startBtn && cfg.cta) startBtn.textContent = String(cfg.cta);

  var stepIndex = 0;
  var answers = {};
  var lastApplyPlan = null;
  var applyPreviewToken = 0;

  function hasAllAnswers() {
    for (var i = 0; i < cfg.steps.length; i++) {
      var step = cfg.steps[i];
      if (!answers[step.key]) return false;
    }
    return true;
  }

  function egPickerHasActiveFilterAnswer(step, answersObj) {
  if (!step) return false;

  var filterMode = String(step.filter_mode || "");
  if (filterMode !== "tag" && filterMode !== "tag_multi") return false;

  var answer = answersObj ? answersObj[step.key] : null;
  if (!answer) return false;
  if (answer === "__any__") return false;

  if (Array.isArray(answer)) return answer.length > 0;
  return true;
}

function egPickerBuildEgSelectionsFromAnswers(pickerCfg, answersObj, omitKeysMap) {
  var out = new Map();
  var i;

  omitKeysMap = omitKeysMap || {};

  for (i = 0; i < pickerCfg.steps.length; i++) {
    var step = pickerCfg.steps[i];
    if (!step || !step.key) continue;
    if (omitKeysMap[step.key]) continue;
    if (!egPickerHasActiveFilterAnswer(step, answersObj)) continue;

    var answer = answersObj[step.key];
    var values = Array.isArray(answer) ? answer : [answer];
    var set = new Set();

    for (var v = 0; v < values.length; v++) {
      var fullTag = String(values[v] || "").replace(/^\s+|\s+$/g, "");
      if (!fullTag) continue;
      set.add(fullTag);
    }

    if (set.size) out.set(step.key, set);
  }

  return out;
}

function egPickerCountMatches(products, pickerCfg, answersObj, omitKeysMap) {
  if (!products || !products.length) return 0;
  if (typeof egProductMatchesSelections !== "function") return 0;

  var egSel = egPickerBuildEgSelectionsFromAnswers(pickerCfg, answersObj, omitKeysMap);
  var shopifySel = new Map();
  var count = 0;

  for (var i = 0; i < products.length; i++) {
    if (egProductMatchesSelections(products[i], shopifySel, egSel)) {
      count++;
    }
  }

  return count;
}

async function egResolvePickerApplyPlan(root, pickerCfg, answersObj) {
  if (!root || !pickerCfg) {
    return {
      mode: "none",
      count: 0,
      omitKeys: {},
      note: ""
    };
  }

  var handle = String(root.getAttribute("data-eg-collection") || "");
  if (!handle || typeof egGetFullCollectionProducts !== "function") {
    return {
      mode: "none",
      count: 0,
      omitKeys: {},
      note: ""
    };
  }

  var allProducts = await egGetFullCollectionProducts(handle);
  allProducts = allProducts || [];

  var dbOn = egPickerIsDbModeOnFromUrl();

  var egProducts = egPickerFilterProductsForScope(allProducts, "eg");
  var dbProducts = egPickerFilterProductsForScope(allProducts, "db");

  var egPlan = egResolvePickerPlanForPool(egProducts, pickerCfg, answersObj);
  var dbPlan = egResolvePickerPlanForPool(dbProducts, pickerCfg, answersObj);

  var egScore = egPickerScorePlan(egPlan);
  var dbScore = egPickerScorePlan(dbPlan);

  var autoEnableDb = (
    !dbOn &&
    dbPlan.count > 0 &&
    (
      egPlan.count <= 0 ||
      (
        egScore <= 35 &&
        dbScore >= (egScore + 40)
      )
    )
  );

  var suggestDb = (!dbOn && !autoEnableDb && egPickerShouldSuggestDb(egPlan, dbPlan));

  var visiblePlan = dbOn ? dbPlan : egPlan;
  if (autoEnableDb) visiblePlan = dbPlan;

  return {
    mode: visiblePlan.mode,
    count: visiblePlan.count,
    omitKeys: visiblePlan.omitKeys || {},
    note: visiblePlan.note || "",
    scope: (dbOn || autoEnableDb) ? "db" : "eg",
    dbOn: dbOn,
    autoEnableDb: autoEnableDb,
    suggestDb: suggestDb,
    egScore: egScore,
    dbScore: dbScore,
    egPlan: egPlan,
    dbPlan: dbPlan
  };
}

function resetApplyBtnUi() {
  if (!applyBtn) return;

  applyBtn.disabled = true;
  applyBtn.textContent = "Show Matches";
}

function updateApplyBtnPreview() {
  if (!applyBtn) return;

  if (stepIndex !== cfg.steps.length - 1 || !hasAllAnswers()) {
    resetApplyBtnUi();
    return;
  }

  var token = ++applyPreviewToken;
  applyBtn.disabled = true;
  applyBtn.textContent = "Checking...";

  egResolvePickerApplyPlan(root, cfg, answers).then(function (plan) {
    if (token !== applyPreviewToken) return;

    lastApplyPlan = plan || null;
    window.__egPickerLastApplyPlan = lastApplyPlan;
    if (typeof window.egSyncDbModeBlockUi === "function") {
      window.egSyncDbModeBlockUi();
    }

    if (!plan || !plan.count) {
      applyBtn.disabled = true;
      applyBtn.textContent = "No Matches Found";
      return;
    }

    applyBtn.disabled = false;

    if (plan.autoEnableDb) {
      applyBtn.textContent = "Show Full Database Matches";
    } else {
      applyBtn.textContent = (plan.mode === "closest") ? "Show Closest Matches" : "Show Best Matches";
    }
  })["catch"](function () {
    if (token !== applyPreviewToken) return;
    applyBtn.disabled = false;
    applyBtn.textContent = "Show Matches";
  });
}

function getAnswerLabel(step, value) {
  var options = egPickerGetStepOptions(step, answers);
  if (!step || !options || !options.length) return String(value || "");

  var valueIsArray = Array.isArray(value);

  for (var i = 0; i < options.length; i++) {
    var opt = options[i];
    if (!opt) continue;

    var optVal = opt.value;
    var optIsArray = Array.isArray(optVal);

    if (valueIsArray && optIsArray) {
      if (optVal.length !== value.length) continue;

      var allMatch = true;
      for (var j = 0; j < optVal.length; j++) {
        if (String(optVal[j]) !== String(value[j])) {
          allMatch = false;
          break;
        }
      }

      if (allMatch) {
        return String(opt.label || "");
      }
    } else if (!valueIsArray && !optIsArray) {
      if (String(optVal) === String(value)) {
        return String(opt.label || value || "");
      }
    } else if (optIsArray && !valueIsArray) {
      for (var k = 0; k < optVal.length; k++) {
        if (String(optVal[k]) === String(value)) {
          return String(opt.label || value || "");
        }
      }
    }
  }

  if (valueIsArray) {
    return value.join(", ");
  }

  return String(value || "");
}

function egPickerGetStepOptions(step, answersObj) {
  if (!step) return [];

  var answerKey = String(step.options_by_answer_key || "");
  var map = step.options_by_answer || null;

  if (answerKey && map && answersObj) {
    var parentAnswer = answersObj[answerKey];
    var branch = map[parentAnswer];
    if (branch && branch.length) return branch;
  }

  return step.options || [];
}

function egPickerGetStepByKey(key) {
  for (var i = 0; i < cfg.steps.length; i++) {
    if (cfg.steps[i] && cfg.steps[i].key === key) return cfg.steps[i];
  }
  return null;
}

function egPickerStepHasActiveAnswer(step) {
  if (!step || !step.key) return false;
  var val = answers[step.key];
  if (!val) return false;
  if (val === "__any__") return false;
  if (Array.isArray(val)) return val.length > 0;
  return true;
}

function egPickerGetAppliedFilterKeys(plan) {
  var out = [];
  var omit = (plan && plan.omitKeys) ? plan.omitKeys : {};

  for (var i = 0; i < cfg.steps.length; i++) {
    var step = cfg.steps[i];
    if (!step || !step.key) continue;

    var mode = String(step.filter_mode || "");
    if (mode !== "tag" && mode !== "tag_multi") continue;
    if (!egPickerStepHasActiveAnswer(step)) continue;
    if (omit[step.key]) continue;

    out.push(step.key);
  }

  return out;
}

function egPickerGetPreferenceKeys() {
  var out = [];

  for (var i = 0; i < cfg.steps.length; i++) {
    var step = cfg.steps[i];
    if (!step || !step.key) continue;

    if (String(step.filter_mode || "") !== "none") continue;
    if (!egPickerStepHasActiveAnswer(step)) continue;

    out.push(step.key);
  }

  return out;
}

function egPickerGetRelaxedKeys(plan) {
  var out = [];
  var omit = (plan && plan.omitKeys) ? plan.omitKeys : {};

  for (var key in omit) {
    if (!omit.hasOwnProperty(key)) continue;

    var step = egPickerGetStepByKey(key);
    if (!step) continue;
    if (!egPickerStepHasActiveAnswer(step)) continue;

    out.push(key);
  }

  return out;
}

function egPickerGetLabelsForKeys(keys) {
  var out = [];

  for (var i = 0; i < keys.length; i++) {
    var step = egPickerGetStepByKey(keys[i]);
    if (!step) continue;

    var val = answers[step.key];
    if (!val) continue;

    out.push(getAnswerLabel(step, val));
  }

  return out;
}

function egPickerGetLowResultMessage(plan, answers) {
  if (!plan || typeof plan.count !== "number") return "";

  var count = plan.count;

  if (count === 0) {
    return "We could not find any strong matches for this combination. Try changing one of your answers.";
  }

  if (count <= 4) {
    return "This combination is very specific, so only a small number of products match.";
  }

  if (count <= 10) {
    return "This is a fairly narrow result set, but still gives a good selection of options.";
  }

  return "";
}

function egPickerGetScopeBulletText(plan) {
  if (!plan) return "";

  if (plan.scope === "db" && plan.autoEnableDb) {
    return "Showing full-database matches because our range did not return strong enough results.";
  }

  if (plan.scope === "eg" && plan.suggestDb) {
    return "Showing the best matches from our range. Broader alternatives are available in DB Mode.";
  }

  if (plan.scope === "db") {
    return "Showing matches from the full database, including products outside our range.";
  }

  return "Showing matches from our range.";
}

function egPickerIsDbModeOnFromUrl() {
  var sp = new URLSearchParams(window.location.search || "");
  return sp.get("eg_show_legacy") === "1";
}

function egPickerIsEgRangeProduct(p) {
  var v = (p && p.legacy_collection !== undefined) ? p.legacy_collection : null;
  return (v === false || v === 0 || v === "0" || v === "false");
}

function egPickerFilterProductsForScope(products, scope) {
  var arr = products || [];

  if (scope === "db") return arr.slice ? arr.slice(0) : arr;

  var out = [];
  for (var i = 0; i < arr.length; i++) {
    if (egPickerIsEgRangeProduct(arr[i])) out.push(arr[i]);
  }
  return out;
}

function egResolvePickerPlanForPool(products, pickerCfg, answersObj) {
  products = products || [];

  var exactCount = egPickerCountMatches(products, pickerCfg, answersObj, {});
  if (exactCount > 0) {
    return {
      mode: "exact",
      count: exactCount,
      omitKeys: {},
      note: ""
    };
  }

  var relaxOrder =
    (pickerCfg.fallback && pickerCfg.fallback.relaxOrder && pickerCfg.fallback.relaxOrder.length)
      ? pickerCfg.fallback.relaxOrder.slice(0)
      : ["firmness"];

  var omitKeys = {};
  for (var i = 0; i < relaxOrder.length; i++) {
    var key = String(relaxOrder[i] || "");
    if (!key) continue;

    var step = null;
    for (var s = 0; s < pickerCfg.steps.length; s++) {
      if (pickerCfg.steps[s] && pickerCfg.steps[s].key === key) {
        step = pickerCfg.steps[s];
        break;
      }
    }

    if (!step) continue;
    if (!egPickerHasActiveFilterAnswer(step, answersObj)) continue;

    omitKeys[key] = true;

    var relaxedCount = egPickerCountMatches(products, pickerCfg, answersObj, omitKeys);
    if (relaxedCount > 0) {
      var note = "";

      if (key === "firmness") {
        note = "No exact matches found, so we widened firmness to show the closest options.";
      } else {
        note = "No exact matches found, so we widened one of the weaker filters to show the closest options.";
      }

      return {
        mode: "closest",
        count: relaxedCount,
        omitKeys: omitKeys,
        note: note
      };
    }
  }

  return {
    mode: "none",
    count: 0,
    omitKeys: {},
    note: "No exact or close matches found. Try changing one of your answers."
  };
}

function egPickerScorePlan(plan) {
  if (!plan || !plan.count) return 0;

  var score = 0;
  var count = parseInt(plan.count, 10) || 0;
  var relaxedCount = 0;
  var k;

  if (plan.omitKeys) {
    for (k in plan.omitKeys) {
      if (plan.omitKeys.hasOwnProperty(k) && plan.omitKeys[k]) {
        relaxedCount++;
      }
    }
  }

  if (plan.mode === "exact") {
    score += 120;
  } else if (plan.mode === "closest") {
    score += 70;
  }

  if (count >= 24) score += 36;
  else if (count >= 16) score += 28;
  else if (count >= 10) score += 20;
  else if (count >= 6) score += 12;
  else if (count >= 3) score += 6;
  else if (count >= 1) score += 2;

  if (count <= 2) score -= 18;
  else if (count <= 4) score -= 10;
  else if (count <= 8) score -= 4;

  if (relaxedCount === 1) score -= 14;
  else if (relaxedCount >= 2) score -= (14 + ((relaxedCount - 1) * 10));

  return score;
}

function egPickerShouldSuggestDb(egPlan, dbPlan) {
  if (!egPlan || !dbPlan) return false;
  if (!(dbPlan.count > 0)) return false;
  if (egPlan.count <= 0) return true;

  var egScore = egPickerScorePlan(egPlan);
  var dbScore = egPickerScorePlan(dbPlan);
  var gap = dbScore - egScore;

  if (gap >= 28) return true;

  if (egPlan.mode === "closest" && dbPlan.mode === "exact" && gap >= 18) {
    return true;
  }

  if ((parseInt(egPlan.count, 10) || 0) <= 4 && (parseInt(dbPlan.count, 10) || 0) >= 10 && gap >= 14) {
    return true;
  }

  return false;
}

function showResultsScreen() {
  setPickerResultsState(true);

  var plan = lastApplyPlan || {
    mode: "exact",
    omitKeys: {},
    note: ""
  };

  var appliedKeys = egPickerGetAppliedFilterKeys(plan);
  var preferenceKeys = egPickerGetPreferenceKeys();
  var relaxedKeys = egPickerGetRelaxedKeys(plan);

  var appliedLabels = egPickerGetLabelsForKeys(appliedKeys);
  var preferenceLabels = egPickerGetLabelsForKeys(preferenceKeys);
  var relaxedLabels = egPickerGetLabelsForKeys(relaxedKeys);

  if (resetBtn) resetBtn.style.display = "";
  if (dbCtaBtn) dbCtaBtn.style.display = "none";

  if (resultPicksEl) resultPicksEl.innerHTML = "";
  if (resultSummaryListEl) resultSummaryListEl.innerHTML = "";
  if (resultDbNoteEl) {
    resultDbNoteEl.style.display = "none";
    resultDbNoteEl.textContent = "";
  }

  for (var i = 0; i < appliedKeys.length; i++) {
    var step = egPickerGetStepByKey(appliedKeys[i]);
    if (!step) continue;

    var picked = answers[step.key];
    if (!picked) continue;

    var item = document.createElement("button");
    item.type = "button";
    item.className = "eg-collection-picker__result-chip";
    item.setAttribute("data-eg-picker-result-step", String(cfg.steps.indexOf(step)));
    item.innerHTML =
      '<span class="eg-collection-picker__result-chip-text"></span>' +
      '<span class="eg-collection-picker__result-chip-x">×</span>';

    var textEl = item.querySelector(".eg-collection-picker__result-chip-text");
    if (textEl) textEl.textContent = getAnswerLabel(step, picked);

    if (resultPicksEl) resultPicksEl.appendChild(item);
  }

  progressEl.style.display = "none";
  questionEl.style.display = "none";
  optionsEl.style.display = "none";
  backBtn.style.display = "none";
  applyBtn.style.display = "none";

  if (editBtn) editBtn.style.display = "";
  if (resultMetaBox) resultMetaBox.style.display = "";
  if (resultSummaryBox) resultSummaryBox.style.display = "";

  if (resultTitleEl) {
    var titlePrefix = (plan.mode === "closest")
      ? "Showing closest matches for"
      : "Showing best matches for";

    var titleCount = "";
    if (plan && typeof plan.count === "number" && plan.count > 0) {
      titleCount = " (" + plan.count + (plan.count === 1 ? " product" : " products") + ")";
    }

    resultTitleEl.textContent = titlePrefix + titleCount;
  }

  if (resultSummaryTitleEl) {
    resultSummaryTitleEl.textContent = (plan.mode === "closest")
      ? "Closest-match summary"
      : "Recommendation summary";
  }

  if (resultSummaryListEl) {
    var glideText = "";
    var sizeText = "";
    var priorityText = "";
    var summaryCfg = (cfg && cfg.summary) ? cfg.summary : null;

    if (summaryCfg) {
      if (typeof summaryCfg.glide === "function") {
        glideText = String(summaryCfg.glide(answers.surface_type) || "");
      }
      if (typeof summaryCfg.size === "function") {
        sizeText = String(summaryCfg.size(answers.movement_space) || "");
      }
      if (typeof summaryCfg.priority === "function") {
        priorityText = String(summaryCfg.priority(answers.secondary_priority) || "");
      }
    }

    if (glideText) {
      var liA = document.createElement("li");
      liA.textContent = glideText;
      resultSummaryListEl.appendChild(liA);
    }

    if (appliedLabels.length) {
      var liB = document.createElement("li");
      liB.textContent = "Selected feel: " + appliedLabels.join(", ") + ".";
      resultSummaryListEl.appendChild(liB);
    }

    if (sizeText) {
      var liC = document.createElement("li");
      liC.textContent = sizeText;
      resultSummaryListEl.appendChild(liC);
    }

    if (priorityText) {
      var liD = document.createElement("li");
      liD.textContent = priorityText;
      resultSummaryListEl.appendChild(liD);
    }
  }

  if (helpTitleEl) {
    helpTitleEl.textContent = (plan.mode === "closest")
      ? "Why these results"
      : "Why these results";
  }

  if (helpTextEl) {
    helpTextEl.textContent = "These results were chosen using your answers and then ranked by your softer preferences.";
  }

  if (helpListEl) {
    helpListEl.innerHTML = "";

    var scopeBullet = egPickerGetScopeBulletText(plan);

    if (plan && plan.suggestDb && resultDbNoteEl) {
      resultDbNoteEl.textContent = "Want to see a wider set of matches?";
      resultDbNoteEl.style.display = "";
    } else if (plan && plan.autoEnableDb && resultDbNoteEl) {
      resultDbNoteEl.textContent = "DB Mode was enabled automatically because our range did not return strong enough matches.";
      resultDbNoteEl.style.display = "";
    } else if (scopeBullet) {
      var liScope = document.createElement("li");
      liScope.textContent = scopeBullet;
      helpListEl.appendChild(liScope);
    }

    if (appliedLabels.length) {
      var li1 = document.createElement("li");
      li1.textContent =
        "Applied as filters: " +
        appliedLabels.join(", ") +
        "." +
        (plan && typeof plan.count === "number" && plan.count > 0
          ? " " + plan.count + (plan.count === 1 ? " product in this result set." : " products in this result set.")
          : "");
      helpListEl.appendChild(li1);
    }

    if (preferenceLabels.length) {
      var li2 = document.createElement("li");
      li2.textContent = "Used to rank the results: " + preferenceLabels.join(", ") + ".";
      helpListEl.appendChild(li2);
    }

    if (relaxedLabels.length) {
      var li3 = document.createElement("li");
      li3.textContent = "Widened " + relaxedLabels.join(", ") + " to avoid zero results.";
      helpListEl.appendChild(li3);
    }

    if (plan && typeof plan.count === "number" && plan.count <= 5) {
      var suggestion = "";

      if (answers.firmness && answers.firmness !== "__any__") {
        suggestion = "Try changing base feel to broaden your options.";
      } else if (answers.surface_material && answers.surface_material !== "__any__") {
        suggestion = "Try removing the material preference to see more options.";
      } else {
        suggestion = "Try adjusting one of your answers to widen the result set.";
      }

      var liSuggest = document.createElement("li");
      liSuggest.textContent = suggestion;
      helpListEl.appendChild(liSuggest);
    }

    if (plan && plan.suggestDb && dbCtaBtn) {
      dbCtaBtn.style.display = "";
    }
  }
}

function showQuestionScreen() {
  setPickerResultsState(false);

  progressEl.style.display = "";
  questionEl.style.display = "";
  optionsEl.style.display = "";
  backBtn.style.display = stepIndex > 0 ? "" : "none";
  applyBtn.style.display = (stepIndex === cfg.steps.length - 1 && hasAllAnswers()) ? "" : "none";

  if (resultMetaBox) resultMetaBox.style.display = "none";
  if (resultSummaryBox) resultSummaryBox.style.display = "none";
  if (resultDbNoteEl) {
    resultDbNoteEl.style.display = "none";
    resultDbNoteEl.textContent = "";
  }
  if (editBtn) editBtn.style.display = "none";
  if (dbCtaBtn) dbCtaBtn.style.display = "none";

  var step = cfg.steps[stepIndex];
  if (step) {
    if (helpTitleEl) helpTitleEl.textContent = String(step.help_title || "");
    if (helpTextEl) helpTextEl.textContent = String(step.help_text || "");

    if (helpListEl) {
      helpListEl.innerHTML = "";
      var points = step.help_points || [];
      for (var p = 0; p < points.length; p++) {
        var li = document.createElement("li");
        li.textContent = String(points[p] || "");
        helpListEl.appendChild(li);
      }
    }
  }
}

  function renderStep() {
    var step = cfg.steps[stepIndex];
    if (!step) return;

      if (resetBtn) {
        resetBtn.style.display = stepIndex > 0 ? "" : "none";
      }

    showQuestionScreen();

    progressEl.textContent = "Step " + (stepIndex + 1) + " of " + cfg.steps.length;
    questionEl.textContent = String(step.question || "");
    optionsEl.innerHTML = "";

    var stepOptions = egPickerGetStepOptions(step, answers);

    for (var i = 0; i < stepOptions.length; i++) {
      var opt = stepOptions[i];
      if (!opt) continue;

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "eg-collection-picker__option";
      btn.setAttribute("data-eg-picker-option-index", String(i));
      btn.textContent = String(opt.label || opt.value || "");

      if (answers[step.key] === opt.value) {
        btn.classList.add("is-selected");
      }

      optionsEl.appendChild(btn);
    }

    backBtn.style.display = stepIndex > 0 ? "" : "none";
    applyBtn.style.display = (stepIndex === cfg.steps.length - 1 && hasAllAnswers()) ? "" : "none";
    updateApplyBtnPreview();
  }

    function openPanel() {
        setPickerOpenState(true);
        setPickerResultsState(false);

        panel.style.display = "";
        startBtn.style.display = "none";
        if (closeBtn) closeBtn.style.display = "";

        stepIndex = 0;
        answers = {};
        lastApplyPlan = null;
        applyPreviewToken++;

        if (resultMetaBox) resultMetaBox.style.display = "none";
        if (resultPicksEl) resultPicksEl.innerHTML = "";
        if (resultSummaryListEl) resultSummaryListEl.innerHTML = "";
        if (editBtn) editBtn.style.display = "none";
        if (dbCtaBtn) dbCtaBtn.style.display = "none";

        renderStep();
    }

function resetPicker() {
  setPickerResultsState(false);

  stepIndex = 0;
  answers = {};
  lastApplyPlan = null;
    window.__egPickerLastApplyPlan = null;

if (typeof window.egSyncDbModeBlockUi === "function") {
  window.egSyncDbModeBlockUi();
}
  applyPreviewToken++;

  if (resultMetaBox) {
    resultMetaBox.style.display = "none";
  }

  if (resultPicksEl) {
    resultPicksEl.innerHTML = "";
  }

  if (resultSummaryListEl) {
    resultSummaryListEl.innerHTML = "";
  }

  if (editBtn) {
    editBtn.style.display = "none";
  }

  if (dbCtaBtn) {
    dbCtaBtn.style.display = "none";
  }

  optionsEl.innerHTML = "";
  progressEl.textContent = "";
  questionEl.textContent = "";

  progressEl.style.display = "";
  questionEl.style.display = "";
  optionsEl.style.display = "";

  backBtn.style.display = "none";
  applyBtn.style.display = "none";

  renderStep();
}

function closePicker() {
  setPickerOpenState(false);
  setPickerResultsState(false);

  panel.style.display = "none";
  startBtn.style.display = "";
  if (resetBtn) resetBtn.style.display = "none";
  if (closeBtn) closeBtn.style.display = "none";

  stepIndex = 0;
  answers = {};
  lastApplyPlan = null;
    window.__egPickerLastApplyPlan = null;

if (typeof window.egSyncDbModeBlockUi === "function") {
  window.egSyncDbModeBlockUi();
}
  applyPreviewToken++;

  optionsEl.innerHTML = "";
  progressEl.textContent = "";
  questionEl.textContent = "";

  progressEl.style.display = "";
  questionEl.style.display = "";
  optionsEl.style.display = "";

  backBtn.style.display = "none";
  applyBtn.style.display = "none";

  if (resultMetaBox) {
    resultMetaBox.style.display = "none";
  }

  if (resultPicksEl) {
    resultPicksEl.innerHTML = "";
  }

  if (resultSummaryListEl) {
    resultSummaryListEl.innerHTML = "";
  }

  if (editBtn) {
    editBtn.style.display = "none";
  }

  if (dbCtaBtn) {
    dbCtaBtn.style.display = "none";
  }

  if (helpTitleEl) helpTitleEl.textContent = "";
  if (helpTextEl) helpTextEl.textContent = "";
  if (helpListEl) helpListEl.innerHTML = "";
}

  startBtn.addEventListener("click", function () {
    openPanel();
  });

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      resetPicker();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closePicker();
    });
  }

  backBtn.addEventListener("click", function () {
    if (stepIndex > 0) {
      stepIndex--;
      renderStep();
    }
  });

  if (editBtn) {
    editBtn.addEventListener("click", function () {
      renderStep();
    });
  }

  if (dbCtaBtn) {
    dbCtaBtn.addEventListener("click", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("eg_show_legacy", "1");
      u.searchParams.delete("page");

      history.replaceState({}, "", u.toString());

      if (typeof egApplyPrettyUrlToAddressBar === "function") {
        try { egApplyPrettyUrlToAddressBar(); } catch (e1) {}
      }

      var legacyToggle = document.querySelector("[data-eg-legacy-toggle]");
      var legacyWrap = legacyToggle && legacyToggle.closest ? legacyToggle.closest(".eg-collection-legacy-switch") : null;
      if (legacyToggle) legacyToggle.checked = true;
      if (legacyWrap && legacyWrap.classList) legacyWrap.classList.add("is-on");

      if (lastApplyPlan && lastApplyPlan.dbPlan) {
        lastApplyPlan = {
          mode: lastApplyPlan.dbPlan.mode,
          count: lastApplyPlan.dbPlan.count,
          omitKeys: lastApplyPlan.dbPlan.omitKeys || {},
          note: lastApplyPlan.dbPlan.note || "",
          scope: "db",
          dbOn: true,
          autoEnableDb: false,
          suggestDb: false,
          egPlan: lastApplyPlan.egPlan || null,
          dbPlan: lastApplyPlan.dbPlan
        };
      }

      window.__egPickerLastApplyPlan = lastApplyPlan;
if (typeof window.egSyncDbModeBlockUi === "function") {
  window.egSyncDbModeBlockUi();
}

      showResultsScreen();

      if (root && typeof root.__egClientRenderRefresh === "function") {
        root.__egClientRenderRefresh();
      } else if (typeof egCollectionsRefresh === "function") {
        egCollectionsRefresh(root);
      } else if (typeof egClientRenderRefresh === "function") {
        egClientRenderRefresh(root);
      } else if (typeof egClientRenderInit === "function") {
        egClientRenderInit(root);
      }
    });
  }

  optionsEl.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-eg-picker-option-index]");
    if (!btn) return;

    var step = cfg.steps[stepIndex];
    if (!step) return;

    var optIndex = parseInt(btn.getAttribute("data-eg-picker-option-index"), 10);
    if (isNaN(optIndex)) return;

    var stepOptions = egPickerGetStepOptions(step, answers);
    if (!stepOptions[optIndex]) return;

    answers[step.key] = stepOptions[optIndex].value;

    for (var clearIdx = stepIndex + 1; clearIdx < cfg.steps.length; clearIdx++) {
      if (cfg.steps[clearIdx] && cfg.steps[clearIdx].key) {
        delete answers[cfg.steps[clearIdx].key];
      }
    }

    lastApplyPlan = null;
      window.__egPickerLastApplyPlan = null;
if (typeof window.egSyncDbModeBlockUi === "function") {
  window.egSyncDbModeBlockUi();
}
    applyPreviewToken++;

    if (stepIndex < cfg.steps.length - 1) {
      stepIndex++;
      renderStep();
    } else {
      renderStep();
    }
  });

  if (resultPicksEl) {
  resultPicksEl.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-eg-picker-result-step]");
    if (!btn) return;

    var idx = parseInt(btn.getAttribute("data-eg-picker-result-step"), 10);
    if (isNaN(idx)) return;
    if (idx < 0 || idx >= cfg.steps.length) return;

    stepIndex = idx;
    renderStep();
  });
}

  applyBtn.addEventListener("click", function () {
    if (applyBtn.disabled) return;

    applyBtn.disabled = true;
    applyBtn.textContent = "Applying...";

    egResolvePickerApplyPlan(root, cfg, answers).then(function (plan) {
      lastApplyPlan = plan || null;
      window.__egPickerLastApplyPlan = lastApplyPlan;

      if (typeof window.egSyncDbModeBlockUi === "function") {
        window.egSyncDbModeBlockUi();
      }

      if (!plan || !plan.count) {
        updateApplyBtnPreview();
        return;
      }

      egSetPickerSelectionsInUrl(
        root,
        cfg,
        answers,
        plan.omitKeys || {},
        !!plan.autoEnableDb || plan.scope === "db"
      );

      showResultsScreen();
    })["catch"](function () {
      updateApplyBtnPreview();
    });
  });
}
  window.egCollectionPickerInit = bindCollectionPicker;
})();